import { useEffect } from "react";
import { gsap, ScrollTrigger, prefersReducedMotion } from "../../utils/gsap";

// Scroll-driven timeline: the progress line fills as you scroll, each node
// lights up when reached and each card slides in. Re-runs when `deps` change.
export default function useTimeline(rootRef, deps = []) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    const items = Array.from(root.querySelectorAll(".tl-item"));
    const progress = root.querySelector(".tl-progress");

    if (prefersReducedMotion()) {
      items.forEach((i) => i.classList.add("is-active"));
      if (progress) progress.style.transform = "scaleY(1)";
      return undefined;
    }

    const ctx = gsap.context(() => {
      if (progress) {
        gsap.fromTo(
          progress,
          { scaleY: 0 },
          {
            scaleY: 1,
            ease: "none",
            scrollTrigger: {
              trigger: root.querySelector(".tl-list"),
              start: "top 65%",
              end: "bottom 65%",
              scrub: 0.4,
            },
          }
        );
      }
      items.forEach((item) => {
        // stays lit once reached; clears only when scrolling back above it
        ScrollTrigger.create({
          trigger: item,
          start: "top 65%",
          onEnter: () => item.classList.add("is-active"),
          onLeaveBack: () => item.classList.remove("is-active"),
          onRefresh: (self) => {
            if (self.progress > 0) item.classList.add("is-active");
          },
        });
        const card = item.querySelector(".tl-card-wrap");
        if (card) {
          gsap.from(card, {
            x: 48,
            autoAlpha: 0,
            duration: 0.8,
            ease: "power3.out",
            scrollTrigger: {
              trigger: item,
              start: "top 88%",
              toggleActions: "play none none reverse",
            },
          });
        }
      });
    }, root);
    return () => ctx.revert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
